// PsyPractice, hukuki belgeler / Български.
//
// Bölüm sırası, başlık numaraları ve hukuki iddialar TÜM dillerde aynıdır; esasa
// ilişkin bir değişiklik bütün dillerde birlikte yapılır ve shared.ts'teki
// LEGAL_VERSION birlikte artar; aksi hâlde kullanıcının onayladığı sürüm ile
// okuduğu metin ayrışır. Yalnızca çeviri eklemek sürümü ARTIRMAZ.
import { LEGAL_VERSION, MERCHANT, type LegalDoc } from "./shared";

// İşletme türünün ADI dile bağlıdır, resmî bilgiler (ad, adres, vergi) değildir;
// bu yüzden shared.ts'te değil, her dilin kendi dosyasında durur.
const OWNER_TYPE = "Едноличен търговец";

const OWNER = 'PsyPractice (по-долу „Платформата“ или „Администраторът на данни“)';

export const DOCS: LegalDoc[] = [
  {
    id: "terms",
    title: "Условия за ползване и отказ от отговорност",
    description:
      "Естество и граници на услугата, какво тя не замества, задължения на потребителя и цялостен отказ от претенции, който поставя цялата отговорност върху потребителя.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Страни и приемане",
        paras: [
          `Настоящите Условия за ползване се сключват между ${OWNER} и всяко физическо или юридическо лице, което получава достъп до Платформата или я използва („Потребителят“). Със създаването на профил, с влизането или с използването на Платформата по какъвто и да е начин Потребителят потвърждава, че е прочел, разбрал и безусловно приема и се задължава да спазва настоящите Условия в тяхната цялост. Всеки, който не приема настоящите Условия, не трябва да използва Платформата.`,
        ],
      },
      {
        heading: "2. Естество и граници на услугата",
        bullets: [
          "PsyPractice е софтуер за СИМУЛАЦИЯ на пациенти с помощта на изкуствен интелект, който позволява на студенти по психология и клиницисти в началото на кариерата си да провеждат и записват собствената си практика по водене на консултативен разговор в безопасна среда.",
          "PsyPractice не е образователна услуга, нито услуга за обучение; това е софтуерен инструмент, който позволява на потребителя да провежда и записва собствената си практика. Платформата не предоставя уроци, учебна програма, изпити или документи и не предоставя никаква титла, квалификация или правоспособност.",
          "Симулираният „пациент“ не е реален клиент; отговорите му се синтезират от изкуствен интелект, могат да бъдат погрешни, непълни, непоследователни или подвеждащи и не претендират за клинична точност или истинност.",
        ],
      },
      {
        heading: "2.1. Какво Платформата не замества",
        bullets: [
          "Тя НЕ е реална терапия или консултиране и не замества никоя сесия, проведена с реален клиент.",
          "Тя НЕ замества клиничната супервизия. Докладите с обратна връзка, създавани от супервизора с изкуствен интелект, са автоматично генериран текст; те не са експертно мнение, официална оценка или бележка.",
          "Тя НЕ е диагностичен, скринингов или оценъчен инструмент; никой резултат от Платформата не може да се използва за диагностика или клинично решение относно което и да е реално лице.",
          "Тя НЕ ТРЯБВА да се използва при кризи или спешни случаи. При суицидни мисли, риск от увреждане на себе си или на други лица или при всяка подобна спешна ситуация затворете Платформата и незабавно се свържете с местните служби за спешна помощ или с компетентно здравно заведение.",
          "Тя НЕ е източник на професионална компетентност, лиценз, титла или правомощие; времето, прекарано в Платформата, и резултатите от нея не могат да бъдат представяни пред никоя институция като доказателство за квалификация.",
        ],
      },
      {
        heading: "3. Декларации и задължения на Потребителя",
        bullets: [
          "Потребителят се задължава да използва Платформата единствено в законни и етични граници, с цел развиване на собствената си професионална практика.",
          "Потребителят се съгласява да НЕ въвежда никакви РЕАЛНИ данни на пациенти/клиенти, идентифицираща информация или здравни данни от специална категория, принадлежащи на което и да е лице; всички правни последици от подобно действие са изключително за сметка на Потребителя.",
          "Потребителят се задължава да не използва никакъв резултат, получен от Платформата, за диагностика, лечение, интервенция или клинично решение относно което и да е реално лице.",
          "Потребителят носи цялата отговорност за собствената си професионална компетентност, обхват на правомощията си и спазване на приложимите професионални и етични правила.",
          "Сигурността на профила, поверителността на паролата и всички действия, извършени през профила на Потребителя, са отговорност на Потребителя.",
          "Профилът е личен; Потребителят се задължава да не го споделя с други лица и да не използва Платформата чрез автоматизирани средства (ботове, скриптове и др.). Използването на платените планове е предмет на ограничение за честна употреба (понастоящем 60 сесии на календарен месец), уредено подробно в Договора за продажба от разстояние.",
        ],
      },
      {
        heading: "4. Цялата отговорност е на Потребителя (отказ от претенции)",
        paras: [
          "Платформата се предоставя „ТАКАВА, КАКВАТО Е“ и „СПОРЕД НАЛИЧНОСТТА“, без каквато и да е изрична или подразбираща се гаранция (включително за непрекъсната работа, липса на грешки, годност за определена цел, точност или актуалност).",
          "Потребителят приема и се задължава, че носи ИЗКЛЮЧИТЕЛНА и ЛИЧНА отговорност за всякакви преки, косвени, случайни, специални или последващи вреди (включително имуществени, неимуществени, вреди за професионалната репутация, загуба на данни, загуба на приходи и вреди, причинени на трети лица), произтичащи от използването или невъзможността за използване на Платформата, от доверяването на резултати от изкуствения интелект или от прилагането на такива резултати по какъвто и да е начин.",
          "В максималната степен, допустима от приложимото право, Потребителят с настоящото неотменимо и безусловно СЕ ОТКАЗВА, сега и предварително, от всякакви претенции, искове и права на обезщетение, които би могъл да предяви срещу Платформата, нейните собственици, служители, разработчици, бизнес партньори и доставчици на услуги във връзка с всяка вреда, която може да претърпи при какъвто и да е неблагоприятен резултат.",
          "Потребителят се задължава също така да обезщети изцяло Платформата и да я предпази от всякакви претенции, вреди, санкции и разходи (включително адвокатски възнаграждения), в случай че към Платформата бъдат отправени претенции от трето лице или институция поради вина, небрежност на Потребителя или използване в нарушение на настоящите Условия.",
        ],
      },
      {
        heading: "5. Ограничаване на отговорността",
        paras: [
          "Без да се засягат императивните разпоредби на приложимото право, общата правна отговорност на Платформата при всички случаи се ограничава до сумата, действително платена от Потребителя на Платформата през 12-те месеца, предхождащи събитието, породило съответната претенция. При безплатно ползване тази сума е нула.",
        ],
      },
      {
        heading: "6. Интелектуална собственост, промени и прекратяване",
        bullets: [
          "Всички права на интелектуална собственост върху Платформата, нейния софтуер, дизайн, шаблони на случаи на пациенти и съдържание принадлежат на Платформата.",
          "Всички прехвърлими имуществени права на интелектуална собственост върху всяко съдържание, което Потребителят създава в Платформата (включително съобщенията, които пише като терапевт, транскриптите на сесиите и производните от тях материали), се считат за отстъпени на Платформата изключително, безсрочно и без възнаграждение в момента на създаването на това съдържание; Платформата може да използва, възпроизвежда и обработва това съдържание в целия свят и без ограничение за всякакви цели, включително за предоставяне на услугата, генериране на обратна връзка и подобряване и развитие на системата (включително подобряване чрез машинно учене). Правата на Потребителя върху личните му данни съгласно приложимото право за защита на данните (GDPR / KVKK) не се засягат от това отстъпване и остават запазени.",
          "Платформата си запазва правото да променя, спира или прекратява настоящите Условия и обхвата на услугата по всяко време, без предварително уведомление.",
          "При нарушение на настоящите Условия Платформата може да спре или закрие профила без предварително уведомление.",
        ],
      },
      {
        heading: "7. Приложимо право и подсъдност",
        paras: [
          "Настоящите Условия се уреждат от законите на Република Турция. Съдилищата и изпълнителните органи на Република Турция са компетентни по всеки спор, който може да възникне.",
          "За потребители, пребиваващи в Европейския съюз, се запазват защитите, предоставени от императивните разпоредби за защита на потребителите в държавата им на пребиваване и от правата им за защита на данните съгласно GDPR; този избор на право не отменя тези императивни разпоредби.",
        ],
      },
    ],
  },
  {
    id: "privacy",
    title: "Политика за поверителност",
    description:
      "GDPR като базов стандарт; обработвани данни, правни основания, хостинг в ЕС, международни трансфери (доставчик на AI) и клаузата по чл. 9 от KVKK за трансграничен трансфер за потребители в Турция.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          `Настоящата Политика за поверителност обяснява как се обработват личните данни в Платформата, управлявана от ${OWNER}. Като базов стандарт за защита на данните политиката следва Общия регламент на ЕС относно защитата на данните (GDPR / 2016/679); за потребители, намиращи се в Турция, допълнително се прилага турският Закон за защита на личните данни № 6698 (KVKK), по-специално член 9 относно трансферите в чужбина. Уведомлението по KVKK и Декларацията за изрично съгласие са неразделна част от тази политика.`,
        ],
      },
      {
        heading: "Администратор на данни и място на хостинг",
        bullets: [
          "Администратор на данни: PsyPractice. Исканията на субектите на данни се обработват чрез канала за контакт, обявен в Платформата (имейл за контакт: info@psycora.com).",
          "Хостинг: Платформата и нейната база данни се хостват в Европейския съюз, в център за данни в Нидерландия (Oracle Cloud). За потребители, намиращи се в ЕС/ЕИП, данните се обработват и съхраняват в ЕС.",
          "Доставчикът на хостинг действа единствено като обработващ данни, по силата на сключено споразумение за обработване на данни (DPA).",
        ],
      },
      {
        heading: "Събирани данни",
        bullets: [
          "Данни за профила: име, имейл, хеширана парола, информация за абонамент/план.",
          "Данни за използването: създадени сесии, транскрипти на сесии, генерирани случаи на пациенти, доклади с обратна връзка от супервизора.",
          "Технически данни: записи на сесии, IP адрес, предпочитания за браузър/локал, журнали за ограничаване на заявките и сигурност.",
        ],
      },
      {
        heading: "Цели на обработването и правно основание (чл. 6 GDPR)",
        bullets: [
          "Изпълнение на договор (чл. 6, пар. 1, б. „б“): създаване на профил, провеждане на сесии, памет на пациента през няколко сесии, оценка от супервизора, управление на абонамента и лимитите за използване.",
          "Легитимен интерес (чл. 6, пар. 1, б. „е“): сигурност, предотвратяване на злоупотреби, подобряване на системата и отстраняване на грешки.",
          "Правно задължение (чл. 6, пар. 1, б. „в“): съхранение/отчитане, произтичащи от законодателството.",
          "Съгласие (чл. 6, пар. 1, б. „а“): обработване за аналитични цели/подобряване на продукта, което не е строго необходимо за услугата, и, където е необходимо, трансфер извън ЕС/ЕИП.",
        ],
      },
      {
        heading: "Международни трансфери",
        paras: [
          "Тъй като хостингът е в ЕС (Нидерландия), данните на потребителите от ЕС/ЕИП по правило се обработват в ЕС без трансфер към трета държава на това ниво. За генериране на отговорите на изкуствения интелект обаче съдържанието на сесиите и заявките се предават на доставчика на AI услугата (Anthropic), чиято инфраструктура за обработване може да се намира извън ЕС/ЕИП (напр. в Съединените щати).",
          "Такива трансфери извън ЕС/ЕИП се основават на подходящи гаранции по чл. 44 и сл. от GDPR, по-специално стандартните договорни клаузи (SCC) на Европейската комисия, и с доставчика се сключва споразумение за обработване на данни (DPA). Платформата НЕ продава лични данни за маркетингови цели; данните не се споделят с трети страни освен когато това е строго необходимо за предоставянето на услугата (със запазване на законните искания на компетентните органи).",
        ],
      },
      {
        heading: "За потребители в Турция: чл. 9 от KVKK (трансфер в чужбина)",
        paras: [
          "Личните данни на потребителите, намиращи се в Турция, се трансферират извън Турция, тъй като хостингът е в Нидерландия (ЕС), и могат също така да бъдат трансферирани на Anthropic за обработване от изкуствен интелект. Тези трансфери попадат в обхвата на чл. 9 от KVKK и се основават на подходящи гаранции (стандартния договор / декларация, публикувани от Съвета) или, където е необходимо, на Вашето изрично съгласие. Обхватът, получателите и целта на трансфера са описани подробно в Уведомлението по KVKK и в Декларацията за изрично съгласие.",
        ],
      },
      {
        heading: "Права на субектите на данни (чл. 15 до 22 GDPR)",
        bullets: [
          "Достъп, коригиране, изтриване („право да бъдеш забравен“) и ограничаване на обработването.",
          "Преносимост на данните: получаване на предоставените от Вас данни в структуриран, широко използван и пригоден за машинно четене формат.",
          "Възражение: възражение срещу обработване, основано на легитимен интерес, и срещу директен маркетинг.",
          "Права във връзка с решения, основани единствено на автоматизирано обработване/профилиране.",
          "Оттегляне на съгласието по всяко време за обработване, основано на съгласие (оттеглянето не засяга законосъобразността на обработването до този момент).",
          "Право на жалба до надзорен орган: съответния орган за защита на данните в ЕС; Органа за защита на личните данни (KVKK) в Турция.",
        ],
      },
      {
        heading: "Съхранение и сигурност",
        bullets: [
          "Данните се съхраняват толкова дълго, колкото изисква целта на обработването, и за сроковете, предвидени в приложимото право; след изтичането на срока те се изтриват или анонимизират.",
          "Чувствителните полета (напр. паролата, кодовете за потвърждение и възстановяване) се съхраняват криптирани/хеширани; достъпът е на база разрешения.",
          "Тъй като никой метод за предаване или съхранение не е 100% сигурен, абсолютна сигурност не може да бъде гарантирана.",
        ],
      },
      {
        heading: "Забрана за данни на реални пациенти",
        paras: [
          "Платформата е софтуер за симулация; въвеждането на лични/здравни данни на реални клиенти е забранено. Цялата отговорност, произтичаща от въвеждане на данни от Потребителя в нарушение на тази забрана, е изключително на Потребителя.",
        ],
      },
    ],
  },
  {
    id: "kvkk",
    title: "Уведомление по KVKK",
    description:
      "Администратор на данни, цели на обработването, правно основание, трансфер и права на субектите на данни съгласно член 10 от Закон № 6698.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Администратор на данни",
        paras: [
          `Съгласно член 10 от турския Закон за защита на личните данни № 6698 („KVKK“) личните Ви данни се обработват от ${OWNER} в качеството му на Администратор на данни, в описания по-долу обхват.`,
        ],
      },
      {
        heading: "Обработвани данни и цели",
        bullets: [
          "Идентичност/контакт (име, имейл): създаване на профил, удостоверяване, комуникация.",
          "Клиентски транзакции (абонамент, план, използване): предоставяне на услугата, фактуриране, прилагане на лимити.",
          "Сигурност на транзакциите (сесия, IP, журнали): сигурност, предотвратяване на злоупотреби, правно задължение.",
          "Потребителско съдържание (транскрипти на сесии, генерирани случаи): предоставяне на софтуерната услуга и генериране на обратна връзка.",
          "Членство в институционална кохорта (идентификатор на кохортата, период на членство): когато потребителят се присъедини към кохорта, водена от институция, видимост за инструктора и администриране на кохортата.",
        ],
      },
      {
        heading: "Правно основание (чл. 5)",
        bullets: [
          "Сключване/изпълнение на договор: данни, необходими за предоставяне на услугата.",
          "Легитимен интерес на администратора на данни: сигурност, предотвратяване на измами, подобряване на системата.",
          "Правно задължение: съхранение/отчитане, произтичащи от законодателството.",
          "Изрично съгласие: трансфер в чужбина (чл. 9) и допълнително обработване, което не е строго необходимо за услугата.",
        ],
      },
      {
        heading: "Трансфер в чужбина (чл. 9)",
        paras: [
          "Тъй като Платформата и нейната база данни се хостват в Европейския съюз, в център за данни в Нидерландия (Oracle Cloud), личните данни на потребителите, намиращи се в Турция, се трансферират извън Турция (към ЕС). Освен това за генериране на отговорите на изкуствения интелект съдържанието на сесиите и заявките могат да бъдат трансферирани на доставчика на AI услугата (Anthropic), чиято инфраструктура за обработване може да се намира извън ЕС/ЕИП (напр. в Съединените щати).",
          "Тези трансфери в чужбина попадат в обхвата на чл. 9 от KVKK и се основават на подходящи гаранции, като стандартния договор / декларация, публикувани от Съвета, или, където е необходимо, на Вашето изрично съгласие. С доставчиците на хостинг и услуги се сключват споразумения за обработване на данни (DPA).",
        ],
      },
      {
        heading: "Институционални кохорти и видимост за инструктора",
        paras: [
          "Ако се присъедините към кохорта, открита от университет, клиника или подобна институция, съдържанието на сесиите Ви (транскрипти) и докладите на супервизора могат да бъдат видени от инструктора на тази кохорта за срока на кохортата. Тази видимост обхваща само сесиите Ви, свързани с кохортата, и приключва с края на членството Ви в кохортата.",
          "Този достъп се получава чрез ОТДЕЛЕН екран за изрично съгласие, показван при присъединяването към кохортата; той не е част от общото приемане на Платформата. Ако не дадете това съгласие, не можете да се присъедините към кохортата, но можете да продължите да използвате Платформата индивидуално, точно както преди. Оттеглянето на съгласието прекратява членството Ви в кохортата и не засяга индивидуалното Ви използване.",
        ],
      },
      {
        heading: "Права на субектите на данни (чл. 11)",
        bullets: [
          "Да научите дали личните Ви данни се обработват и, ако е така, да поискате информация.",
          "Да научите целта на обработването и дали данните се използват в съответствие с тази цел.",
          "Да знаете третите лица, на които се трансферират данните в страната или в чужбина.",
          "Да поискате коригиране на непълно/неправилно обработване и, при наличие на условията, изтриване/унищожаване.",
          "Да възразите срещу резултат във Ваш ущърб, произтичащ единствено от автоматизиран анализ.",
          "Да поискате обезщетение за вреди, претърпени вследствие на незаконосъобразно обработване.",
        ],
      },
      {
        heading: "Заявления",
        paras: [
          "Можете да подавате искания относно правата си чрез канала за контакт, обявен от Администратора на данни. Заявленията се разглеждат в сроковете, предвидени от KVKK и подзаконовите актове към него.",
        ],
      },
    ],
  },
  {
    id: "consent",
    title: "Декларация за изрично съгласие",
    description:
      "Отделно от уведомлението; свободно дадено съгласие за трансфер в чужбина и обработване от изкуствен интелект.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Декларирам, че съм прочел/прочела и разбрал/разбрала Уведомлението по KVKK и че свободно, информирано и изрично давам съгласието си за описаното по-долу обработване. (Съгласно решение № 2018/90 на Съвета по KVKK изричното съгласие се получава отделно от задължението за информиране.)",
        ],
      },
      {
        heading: "Обработване, за което се дава съгласие",
        bullets: [
          "Трансфер на личните ми данни извън Турция и тяхното съхранение и обработване там, тъй като Платформата се хоства в Европейския съюз (Нидерландия / Oracle Cloud) (чл. 9 от KVKK).",
          "Трансфер и обработване на транскриптите на сесиите ми и заявките ми при доставчика на AI услугата (Anthropic), чиято инфраструктура за обработване може да се намира извън ЕС/ЕИП, с цел генериране на отговори от изкуствен интелект (чл. 9 от KVKK).",
          "Обработване за подобряване на продукта и аналитични цели, което не е строго необходимо за предоставянето на услугата.",
          "Получаване на известия, свързани с услугата.",
        ],
      },
      {
        heading: "Оттегляне на съгласието",
        paras: [
          "Разбирам, че мога да оттегля изричното си съгласие по всяко време; тъй като обаче трансферът в чужбина към доставчика на AI е технически необходим за функционирането на услугата, приемам, че оттеглянето на това съгласие може да доведе до невъзможност да използвам съответните функции или услугата като цяло. Оттеглянето не засяга законосъобразността на обработването, извършено до датата на оттеглянето.",
        ],
      },
    ],
  },
  {
    // Counterpart of the TR "outreach" notice; see the comment there.
    id: "outreach",
    title: "Уведомление за комуникация при контакт",
    description:
      "За академични и институционални контакти, получили корпоративен имейл за контакт: откъде идват данните, защо се обработват, правното основание и как да се откажете.",
    updated: "2026-08-06",
    sections: [
      {
        paras: [
          "Настоящото уведомление информира получателите на корпоративни имейли за контакт, изпращани от PsyPractice до университетски катедри по психология и техния академичен състав, в съответствие с член 10 от турския Закон за защита на личните данни № 6698 (KVKK) и Наредбата за реда и принципите за изпълнение на задължението за информиране. Тъй като личните Ви данни не са получени директно от Вас, информирането се извършва най-късно при първия контакт, поради което имейлът за контакт препраща тук.",
        ],
      },
      {
        heading: "1. Администратор на данни",
        bullets: [
          `Име: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Адрес: ${MERCHANT.addressEn}`,
          `Данъчна служба / №: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `Имейл: ${MERCHANT.email}`,
          `Уеб: ${MERCHANT.website}`,
        ],
      },
      {
        heading: "2. Обработвани данни и техният източник",
        paras: [
          "Обработването е ограничено до професионални данни за контакт: име, академична длъжност, университет и катедра, институционален имейл адрес и, където е публикуван, институционален телефонен номер.",
          "Тези данни не са събрани от Вас, а са компилирани от публично публикуваните официални страници на катедри и факултети на университетите. Не се обработват данни от специални категории, а частни (неинституционални) имейл адреси не се използват за контакт.",
        ],
      },
      {
        heading: "3. Цел",
        paras: [
          "Данните Ви се обработват, за да бъде представен софтуерен инструмент, създаден за подготовката на психолози, за да бъде поканена Вашата катедра на разговор за възможен пилотен проект или сътрудничество и за да се води свързаната с това кореспонденция. Те не се използват за никаква друга цел, не се продават и не се трансферират на трети страни за маркетинг.",
        ],
      },
      {
        heading: "4. Правно основание",
        paras: [
          "Обработването се основава на легитимните интереси на администратора на данни съгласно член 5/2-(f) от KVKK, при условие че това не уврежда основните Ви права и свободи: контактът се осъществява само на институционален адрес, само по въпрос, пряко свързан с професионалната област на получателя, и ограничен брой пъти.",
          "Самият факт, че данните са публично достъпни онлайн, не е сам по себе си правно основание. Съветът за защита на личните данни е приел, че публичността на данните не ги прави използваеми за всяка цел и че намерението и целта на публикуването им трябва да се преценяват отделно; поради това член 5/2-(d) не се използва като основание.",
        ],
      },
      {
        heading: "5. Трансфери и съхранение",
        paras: [
          "Кореспонденцията се води чрез доставчик на имейл услуги, чиято инфраструктура може да се намира в чужбина; такива трансфери се извършват с подходящи гаранции съгласно член 9 от KVKK.",
          "Данните Ви се изтриват, когато целта на контакта отпадне или по Ваше искане. След искане за изтриване се пази строго ограничен запис „да не се осъществява контакт“ единствено за да се гарантира, че няма да бъдете потърсени отново; той никога не се използва за контакт.",
        ],
      },
      {
        heading: "6. Търговски електронни съобщения и право на отказ",
        paras: [
          "Промоционалните съобщения попадат в обхвата на Закон № 6563 за регулиране на електронната търговия. Можете да откажете получаването им, без да посочвате причина; отказите се обработват най-късно в рамките на три работни дни, след което не се изпраща повече промоционално съобщение. Достатъчно е да отговорите на получения имейл или да пишете на " + MERCHANT.email + ".",
        ],
      },
      {
        heading: "7. Вашите права",
        paras: [
          "Съгласно член 11 от KVKK имате право да научите дали личните Ви данни се обработват, да поискате информация за тях, да научите целта на обработването и дали данните се използват в съответствие с нея, да знаете третите лица, на които се трансферират в Турция или в чужбина, да поискате коригиране на непълни или неточни данни, да поискате изтриване или унищожаване, да поискате тези действия да бъдат съобщени на третите лица, да възразите срещу резултат във Ваш ущърб, произведен единствено от автоматизиран анализ, и да поискате обезщетение за претърпени вреди.",
          `Исканията могат да се изпращат на ${MERCHANT.email} и получават отговор най-късно в рамките на тридесет дни. Запазвате и правото си да подадете жалба до Съвета за защита на личните данни.`,
        ],
      },
    ],
  },
  {
    id: "cookies",
    title: "Политика за бисквитките",
    description: "Видове използвани бисквитки, техните цели и управление на предпочитанията.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Платформата използва бисквитки и подобни технологии за локално съхранение (localStorage), за да поддържа сесията Ви и да запомня предпочитанията Ви.",
        ],
      },
      {
        heading: "Използвани технологии",
        bullets: [
          "Строго необходими: токен за сесия/удостоверяване, сигурност. Без тях услугата не работи.",
          "Функционални: предпочитание за език/локал (NEXT_LOCALE), предпочитания за интерфейса (напр. тема).",
          "Производителност/сигурност: технически журнали за ограничаване на заявките и откриване на злоупотреби.",
        ],
      },
      {
        heading: "Управление на предпочитанията",
        paras: [
          "Можете да изтривате или блокирате бисквитки в браузъра си; блокирането на строго необходимите бисквитки обаче ще попречи на влизането и на основната функционалност. В съответствие с принципите на GDPR / ePrivacy и Ръководството за бисквитките по KVKK бисквитките, които не са строго необходими, се използват само въз основа на Вашето изрично предпочитание/съгласие.",
        ],
      },
    ],
  },
  {
    id: "about",
    title: "За нас",
    description:
      "Целта на PsyPractice, услугата, която предлага, и данните за контакт с търговеца (продавача).",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "PsyPractice е платформа за симулация на пациенти и клинични умения с помощта на изкуствен интелект, създадена за студенти по психология и новодипломирани клиницисти в началото на кариерата си. Потребителите провеждат текстови терапевтични сесии; в края на всяка сесия супервизор с изкуствен интелект оценява разговора и изготвя доклад с обратна връзка за развитие. Пациентът с изкуствен интелект пренася терапевтичната връзка от сесия на сесия чрез памет между сесиите.",
        ],
      },
      {
        heading: "Нашата мисия",
        paras: [
          "Целта ни е да дадем на бъдещите специалисти по психично здраве безопасна, повторяема среда, в която да практикуват умения за водене на консултативен разговор без никакъв риск да навредят на реални клиенти. PsyPractice не е образователна услуга, нито услуга за обучение; това е софтуерен инструмент, който позволява на потребителя да провежда и записва собствената си практика. Тя не е реална терапия или консултиране, не замества клиничната супервизия, не е диагностичен или оценъчен инструмент и не трябва да се използва при кризи или спешни случаи.",
        ],
      },
      {
        heading: "Какво предлагаме",
        bullets: [
          "Симулация на текстови терапевтични сесии с разнообразни профили на пациенти, синтезирани от клиничната литература.",
          "Автоматизирани доклади с оценка от супервизор след всяка сесия.",
          "Модел „жив пациент“ с памет между сесиите, който развива терапевтичната връзка във времето.",
          "Генериране на собствени пациенти, което позволява на студентите да създават собствени случаи с изкуствен интелект.",
          "Показатели за напредък, които проследяват развитието на микроуменията.",
        ],
      },
      {
        heading: "Информация за продавача / търговеца",
        bullets: [
          `Търговско наименование: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Адрес: ${MERCHANT.addressEn}`,
          `Данъчна служба / №: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `Имейл: ${MERCHANT.email}`,
          `Уеб: ${MERCHANT.website}`,
        ],
      },
    ],
  },
  {
    id: "distance-sales",
    title: "Договор за продажба от разстояние",
    description:
      "Продавач, купувач, услуга, цена, плащане, изпълнение и условия за право на отказ съгласно турския Закон № 6502 и Наредбата за договорите от разстояние.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Страни",
        bullets: [
          `ПРОДАВАЧ: ${MERCHANT.legalName} (${OWNER_TYPE}). Адрес: ${MERCHANT.addressEn}. Данъчна служба/№: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}. Имейл: ${MERCHANT.email}.`,
          "КУПУВАЧ: физическото или юридическото лице, което създава профил в Платформата и закупува платен абонамент („Купувачът“).",
        ],
      },
      {
        heading: "2. Предмет на договора",
        paras: [
          "Предметът на настоящия Договор е да определи правата и задълженията на страните, в съответствие с турския Закон № 6502 за защита на потребителите и Наредбата за договорите от разстояние, относно продажбата и изпълнението на абонамента за дигитална услуга, закупен по електронен път от Купувача чрез Платформата, чиито характеристики и продажна цена са посочени по-долу.",
        ],
      },
      {
        heading: "3. Естество на услугата и цена",
        bullets: [
          "Продаваната услуга представлява функциите за симулация на пациенти с помощта на изкуствен интелект, предлагани в рамките на платен абонаментен план на софтуера PsyPractice (дигитална услуга / право на ползване на софтуера).",
          "PsyPractice не е образователна услуга, нито услуга за обучение; това е софтуерен инструмент, който позволява на потребителя да провежда и записва собствената си практика. Абонаментната такса е възнаграждение за достъп до този софтуер; тя не е такса за уроци, учебна програма, изпити, консултации или какъвто и да е документ.",
          "Съдържанието на плана, срокът (месечен, 4-месечен период или годишен) и актуалната цена се показват ясно на страницата за цени/плащане на Платформата в момента на покупката; общата сума с включени данъци се съобщава на Купувача преди плащането.",
          "Цените се прилагат във валутата, показана в Платформата; освен ако не бъде отказан, абонаментът се подновява автоматично на същата цена в края на избрания срок.",
          "При плановете, предлагани като „неограничени сесии“, използването е предмет на ограничение за честна употреба (понастоящем 60 сесии на календарен месец). След достигане на ограничението нови сесии могат да се започват отново от първия ден на следващия календарен месец; това не поражда право на намаление на цената или възстановяване на суми. Ограничението служи за предотвратяване на споделянето на профили и автоматизираната употреба, като Продавачът не го променя във вреда на Купувача по време на платен абонаментен период.",
        ],
      },
      {
        heading: "4. Плащане",
        paras: [
          "Плащанията се събират сигурно с кредитна/дебитна карта чрез лицензираната платежна институция iyzico. Данните на картата не се съхраняват от Продавача; плащането се обработва чрез сигурните системи на iyzico. При повтарящи се (абонаментни) плащания сумата се удържа автоматично във всеки период на подновяване от картата, одобрена от Купувача.",
        ],
      },
      {
        heading: "5. Изпълнение и доставка",
        paras: [
          "Услугата е дигитална и не включва физическа доставка. След потвърждение на плащането функциите на абонамента стават достъпни в профила на Купувача незабавно. Изпълнението се извършва по електронен път чрез осигуряване на непрекъснат достъп през целия срок на абонамента.",
        ],
      },
      {
        heading: "6. Право на отказ и неговото изключение",
        bullets: [
          "Съгласно член 15/1-(ğ) от Наредбата за договорите от разстояние правото на отказ не може да бъде упражнено за нематериални (дигитални) стоки/услуги, изпълнявани незабавно в електронна форма, когато изпълнението е започнало със съгласието на Купувача.",
          "Купувачът потвърждава в момента на покупката, че услугата ще бъде изпълнена незабавно и че следователно право на отказ не съществува. Купувачът може да откаже абонамента по всяко време, за да спре подновяването; отказът влиза в сила в края на текущия платен период.",
          "За подробните условия за възстановяване вижте „Условия за доставка и възстановяване“.",
        ],
      },
      {
        heading: "7. Спорове и влизане в сила",
        paras: [
          "В случай на спор Купувачът може да се обърне към Потребителския арбитражен комитет или към Потребителските съдилища по местоживеене в рамките на паричните лимити, обявени от Министерството на търговията. Настоящият Договор се сключва и влиза в сила с одобрението на Купувача в електронна форма.",
        ],
      },
    ],
  },
  {
    id: "delivery-refund",
    title: "Условия за доставка и възстановяване",
    description:
      "Доставка на дигиталната услуга, отказ от абонамент, изключението от правото на отказ и условия за възстановяване.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Доставка (дигитална услуга)",
        bullets: [
          "PsyPractice е изцяло дигитална услуга; няма физическо изпращане на продукт или куриерска доставка.",
          "В момента на потвърждаване на плащането функциите на абонамента се активират автоматично и незабавно в профила на Купувача; няма отделен срок за доставка или такса за доставка.",
          "Достъпът до услугата се осъществява през уеб браузъра на всяко устройство, свързано с интернет.",
        ],
      },
      {
        heading: "Отказ от абонамент",
        bullets: [
          "Купувачът може да откаже абонамента по всяко време от настройките на профила. Отказът влиза в сила в края на текущия платен период и спира следващото автоматично подновяване.",
          "След отказа достъпът до услугата продължава до края на платения период.",
        ],
      },
      {
        heading: "Право на отказ и възстановяване",
        bullets: [
          "Тъй като услугата е дигитална услуга, изпълнявана незабавно със съгласието на Купувача, по правило не възниква право на отказ, а следователно и право на възстановяване, съгласно член 15/1-(ğ) от Наредбата за договорите от разстояние.",
          "При явен дефект, като погрешно/двойно таксуване, пълна невъзможност за достъп до услугата по технически причини или подобни, Купувачът може да поиска възстановяване, като се свърже с Продавача в разумен срок от датата на плащането.",
          `Исканията за възстановяване се изпращат на ${MERCHANT.email}; одобрените възстановявания се връщат по картата, използвана за плащането, чрез инфраструктурата на iyzico, по правило в рамките на 14 дни. Срокът за възстановяване може да варира в зависимост от времето за обработка на банката.`,
        ],
      },
      {
        heading: "Контакт",
        paras: [
          `За всички въпроси относно доставка, отказ и възстановяване: ${MERCHANT.email}${MERCHANT.phone ? " · " + MERCHANT.phone : ""}.`,
        ],
      },
    ],
  },
];
